/**
 * 구독 훅
 * SubscriptionContext를 통해 구독 상태에 접근합니다.
 */

import { useContext } from 'react';
import { SubscriptionContext, type SubscriptionContextValue } from '../context/SubscriptionContext';

export function useSubscription(): SubscriptionContextValue {
  const context = useContext(SubscriptionContext);

  if (context === undefined) {
    throw new Error('useSubscription must be used within a SubscriptionProvider');
  }

  return context;
}
